import { memo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export function FilterButton({
  icon,
  content,
  disabled,
  active,
  className,
  mobileIconOnly,
  ...otherProps
}) {
  return (
    <button
      type="button"
      {...otherProps}
      aria-label="filter button"
      className={`${cx('filter-button', { inactive: disabled, active, 'mobile-icon': mobileIconOnly })} ${className}`}
    >
      {icon}
      <span>{content}</span>
    </button>
  );
}

FilterButton.propTypes = {
  icon: PropTypes.node.isRequired,
  content: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  mobileIconOnly: PropTypes.bool,
};

FilterButton.defaultProps = {
  className: '',
  disabled: false,
  active: false,
  mobileIconOnly: false,
};

export default memo(withComponentName(FilterButton));
